(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fresh-sale-top-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fresh-sale-countdown')) return;

  // Input is a wall-clock date in fixed EST. Never parse it in the device timezone.
  function parseEST(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/.exec(value || '');
    if (!match) return NaN;
    const [, year, month, day, hour, minute, second] = match.map(Number);
    const wallTime = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    if (wallTime.getUTCFullYear() !== year || wallTime.getUTCMonth() !== month - 1 ||
        wallTime.getUTCDate() !== day || wallTime.getUTCHours() !== hour ||
        wallTime.getUTCMinutes() !== minute || wallTime.getUTCSeconds() !== second) return NaN;
    return wallTime.getTime() + 5 * 60 * 60 * 1000;
  }

  class SaleCountdown extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.hidden = true;
      this.end = parseEST(this.dataset.endEst);
      if (!Number.isFinite(this.end)) {
        if (window.Shopify?.designMode) console.warn('Sale banner: invalid EST end date. Use YYYY-MM-DDTHH:MM:SS.');
        return;
      }
      this.nodes = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-sale-${unit}]`));
      this.timerElement = this.querySelector('.sale-top__timer');
      const label = this.querySelector('[data-sale-deadline]');
      this.deadlineElement = label;
      if (label) {
        label.textContent = 'Ends ' + new Intl.DateTimeFormat('en-US', {
          timeZone: 'Etc/GMT+5', month: 'short', day: 'numeric', year: 'numeric',
          hour: 'numeric', minute: '2-digit', hour12: true
        }).format(new Date(this.end)) + ' EST';
      }
      this.onVisibility = () => this.update();
      document.addEventListener('visibilitychange', this.onVisibility);
      if (this.update()) this.timer = setInterval(() => this.update(), 1000);
    }

    update() {
      const remaining = this.end - Date.now();
      if (remaining <= 0) {
        if (this.timerElement) this.timerElement.hidden = true;
        if (this.deadlineElement) this.deadlineElement.hidden = true;
        this.hidden = Boolean(this.timerElement);
        this.stop();
        return false;
      }
      if (this.timerElement) this.timerElement.hidden = false;
      if (this.deadlineElement) this.deadlineElement.hidden = false;
      const seconds = Math.ceil(remaining / 1000);
      const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24,
        Math.floor(seconds / 60) % 60, seconds % 60];
      this.nodes.forEach((node, index) => {
        if (node) node.textContent = String(values[index]).padStart(2, '0');
      });
      this.hidden = false;
      return true;
    }

    stop() {
      clearInterval(this.timer);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }

    disconnectedCallback() { this.stop(); }
  }

  customElements.define('fresh-sale-countdown', SaleCountdown);
})();

  } catch(e) { console.error(e); }
})();
})();
